import { render, staticRenderFns } from "./departmentstore.vue?vue&type=template&id=4de533c1&scoped=true&"
import script from "./departmentstore.vue?vue&type=script&lang=js&"
export * from "./departmentstore.vue?vue&type=script&lang=js&"
import style0 from "./departmentstore.vue?vue&type=style&index=0&id=4de533c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de533c1",
  null
  
)

export default component.exports